import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-f6287a32"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = /*#__PURE__*/ _createTextVNode("待支付");
var _hoisted_3 = /*#__PURE__*/ _createTextVNode("待签字");
var _hoisted_4 = /*#__PURE__*/ _createTextVNode("待出检测报告");
var _hoisted_5 = /*#__PURE__*/ _createTextVNode("已完成");
var _hoisted_6 = /*#__PURE__*/ _createTextVNode("申请退款");
var _hoisted_7 = /*#__PURE__*/ _createTextVNode("退款完成");
import { computed } from "vue";
import { Field } from "vant";
export default /*#__PURE__*/ _defineComponent({
    __name: 'orderInfo',
    props: {
        orderInfo: {
            type: Object,
            required: true,
        },
    },
    setup: function (__props) {
        var props = __props;
        var cardType = computed(function () {
            var _a;
            return (_a = [
                { text: "身份证", value: 1 },
                { text: "港澳台居民居住证", value: 2 },
                { text: "护照", value: 3 },
                { text: "台胞证", value: 4 },
                { text: "外国人永久居留身份证", value: 5 },
            ].find(function (item) { var _a; return item.value === ((_a = props.orderInfo) === null || _a === void 0 ? void 0 : _a.certificateType); })) === null || _a === void 0 ? void 0 : _a.text;
        });
        return function (_ctx, _cache) {
            var _a, _b, _c, _d, _e, _f, _g;
            var _component_van_tag = _resolveComponent("van-tag");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(Field), {
                    style: _normalizeStyle({ margin: '0.16rem 0' }),
                    label: "订单状态"
                }, {
                    input: _withCtx(function () {
                        var _a, _b, _c, _d, _e, _f;
                        return [
                            (((_a = props.orderInfo) === null || _a === void 0 ? void 0 : _a.orderStatus) === 1)
                                ? (_openBlock(), _createBlock(_component_van_tag, {
                                    key: 0,
                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                    type: "warning"
                                }, {
                                    default: _withCtx(function () { return [
                                        _hoisted_2
                                    ]; }),
                                    _: 1
                                }, 8, ["style"]))
                                : _createCommentVNode("", true),
                            (((_b = props.orderInfo) === null || _b === void 0 ? void 0 : _b.orderStatus) === 2)
                                ? (_openBlock(), _createBlock(_component_van_tag, {
                                    key: 1,
                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                    type: "warning"
                                }, {
                                    default: _withCtx(function () { return [
                                        _hoisted_3
                                    ]; }),
                                    _: 1
                                }, 8, ["style"]))
                                : _createCommentVNode("", true),
                            ([12, 3, 4, 5, 11].includes((_c = props.orderInfo) === null || _c === void 0 ? void 0 : _c.orderStatus))
                                ? (_openBlock(), _createBlock(_component_van_tag, {
                                    key: 2,
                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                    type: "danger"
                                }, {
                                    default: _withCtx(function () { return [
                                        _hoisted_4
                                    ]; }),
                                    _: 1
                                }, 8, ["style"]))
                                : _createCommentVNode("", true),
                            (((_d = props.orderInfo) === null || _d === void 0 ? void 0 : _d.orderStatus) === 6)
                                ? (_openBlock(), _createBlock(_component_van_tag, {
                                    key: 3,
                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                    type: "success"
                                }, {
                                    default: _withCtx(function () { return [
                                        _hoisted_5
                                    ]; }),
                                    _: 1
                                }, 8, ["style"]))
                                : _createCommentVNode("", true),
                            (((_e = props.orderInfo) === null || _e === void 0 ? void 0 : _e.orderStatus) === 7)
                                ? (_openBlock(), _createBlock(_component_van_tag, {
                                    key: 4,
                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                    type: "danger"
                                }, {
                                    default: _withCtx(function () { return [
                                        _hoisted_6
                                    ]; }),
                                    _: 1
                                }, 8, ["style"]))
                                : _createCommentVNode("", true),
                            (((_f = props.orderInfo) === null || _f === void 0 ? void 0 : _f.orderStatus) === 8)
                                ? (_openBlock(), _createBlock(_component_van_tag, {
                                    key: 5,
                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                    type: "success"
                                }, {
                                    default: _withCtx(function () { return [
                                        _hoisted_7
                                    ]; }),
                                    _: 1
                                }, 8, ["style"]))
                                : _createCommentVNode("", true)
                        ];
                    }),
                    _: 1
                }, 8, ["style"]),
                _createVNode(_unref(Field), {
                    modelValue: (_a = props.orderInfo) === null || _a === void 0 ? void 0 : _a.skuName,
                    name: "产品名称",
                    label: "产品名称",
                    readonly: ""
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(Field), {
                    modelValue: (_b = props.orderInfo) === null || _b === void 0 ? void 0 : _b.hospitalName,
                    name: "就诊医院",
                    label: "就诊医院",
                    readonly: ""
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(Field), {
                    modelValue: (_c = props.orderInfo) === null || _c === void 0 ? void 0 : _c.doctor,
                    name: "就诊医生",
                    label: "科室/医生",
                    readonly: ""
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(Field), {
                    modelValue: (_d = props.orderInfo) === null || _d === void 0 ? void 0 : _d.cardName,
                    name: "受检人",
                    label: "受检人",
                    readonly: "",
                    placeholder: "请输入受检人姓名"
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(Field), {
                    modelValue: _unref(cardType),
                    readonly: "",
                    name: "documentTypePicker",
                    label: "证件类型"
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(Field), {
                    modelValue: (_e = props.orderInfo) === null || _e === void 0 ? void 0 : _e.cardNo,
                    label: "证件号码",
                    readonly: ""
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(Field), {
                    modelValue: (_f = props.orderInfo) === null || _f === void 0 ? void 0 : _f.createTime,
                    label: "下单时间",
                    readonly: ""
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(Field), {
                    modelValue: (_g = props.orderInfo) === null || _g === void 0 ? void 0 : _g.sampleCode,
                    label: "样本编码",
                    readonly: ""
                }, null, 8, ["modelValue"])
            ]));
        };
    }
});
